// extracted by mini-css-extract-plugin
module.exports = {"emptySpacePlaceholder":"Navbar_emptySpacePlaceholder__azPCk","container":"Navbar_container__vShO1","hiddenNav":"Navbar_hiddenNav__HcefX"};